import * as tslib_1 from "tslib";
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { environment } from '../../../../environments/environment';
import { of } from 'rxjs';
import { Geschaeftsvorgang } from './Model/Lieferung';
var CsvDownloadService = /** @class */ (function (_super) {
    tslib_1.__extends(CsvDownloadService, _super);
    function CsvDownloadService(http) {
        var _this = _super.call(this, http, {
            baseUrl: "" + environment.apiHost,
            path: '/makpak/dummy'
        }) || this;
        _this.http = http;
        return _this;
    }
    // getCSVData(packageID: number):Observable<Process[]>{
    //   let urlParam = `${packageID}`;
    //   return super.get(urlParam).map((res:Process[])=>{
    //     return res;
    //   });
    // }
    CsvDownloadService.prototype.getCSVData = function () {
        var processes = [new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
            new Geschaeftsvorgang("id", "test", "test", "test", "test"),
        ];
        return of(processes);
    };
    CsvDownloadService.prototype.getCSVDataGeschaeftsvorgang = function (gv) {
        return of(gv);
    };
    return CsvDownloadService;
}(RESTService));
export { CsvDownloadService };
